<script setup lang="ts">
import { computed, h } from 'vue'
import { icons, isValidIconName } from '@/icons'

const props = withDefaults(defineProps<{
  name: string
  size?: number | string
}>(), {
  size: 16
})

// 开发环境校验：警告无效的图标名称
if (import.meta.env.DEV && !isValidIconName(props.name)) {
  // eslint-disable-next-line no-console
  console.warn(`[BaseIcon] Unknown icon name: "${props.name}". Please ensure the icon is registered in @/icons.`)
}

/**
 * 使用 Vue 3 的 h() 渲染函数动态创建 SVG 组件
 * 通过 innerHTML DOM property 设置图标内容（替代 v-html）
 *
 * 安全性说明：
 * - innerHTML 作为 DOM property 只在渲染时设置一次
 * - 不会因响应式更新而重新执行，比 v-html 更安全
 * - 图标内容来自静态注册表（icons/index.ts），不可被用户注入
 */
const iconSvg = computed(() => {
  const content = icons[props.name]
  if (!content) return null

  return () => h('svg', {
    width: props.size,
    height: props.size,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: '2',
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    innerHTML: content
  })
})
</script>

<template>
  <component :is="iconSvg" v-if="iconSvg" />
</template>
